import { useEffect, useState, useRef } from 'react';
import { Wrapper, Label, Textarea, TabsAndTextareaWrapper, TabsWrapper, Tab } from './styles';

const HistoryTextfield = ({
  history = [],
  label,
  placeholder,
  inputStyle = {},
  onBlur,
  disabled = false,
  activePhase = {},
}) => {
  const [activeTab, setActiveTab] = useState(activePhase);
  useEffect(() => setActiveTab(activePhase), [JSON.stringify(activePhase)]);
  return (
    <Wrapper>
      {label && <Label>{label}</Label>}
      <TabsAndTextareaWrapper>
        <TabsWrapper>
          {[...history, activePhase].map((h, ind) => (
            <Tab
              onClick={() => setActiveTab(h)}
              key={h.phase}
              isActive={h.phase === activeTab?.phase}>
              Phase {h.phase}
            </Tab>
          ))}
        </TabsWrapper>
        <Textarea
          value={activeTab?.value || ''}
          style={inputStyle}
          placeholder={placeholder}
          onChange={(e) => setActiveTab((current) => ({ ...current, value: e.target.value }))}
          onBlur={(e) => onBlur(e.target.value)}
          disabled={disabled || activeTab?.phase !== activePhase?.phase}
          maxRows={6}
          rows={2}
        />
      </TabsAndTextareaWrapper>
    </Wrapper>
  );
};

export default HistoryTextfield;
